/**
 * Returns a stable endpoint label for client diagnostics without retaining
 * query parameters or capability-token path segments.
 */
export const getSafeRequestPath = (url: string | undefined): string => {
  if (!url) return "unknown";

  const path = url.split(/[?#]/, 1)[0] || "unknown";
  return path.replace(
    /(\/case-shares\/)[^/]+/i,
    "$1[redacted]"
  );
};
